
import { rootApi } from '../rootApi';
import { APIResponse, HTTPRequestType } from '../api.types';
import { IThread, GetThreadProps, PostCommentProps, GetCommentsResponse } from './threads.types';

const threadsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    getThread: builder.query<IThread, { thread_id: string }>({
      query: (data) => ({
        url: `/threads/${data.thread_id}`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Thread', id: arg.thread_id }]
    }),

    getCommentsThread: builder.query<GetCommentsResponse, GetThreadProps>({
      query: (data) => ({
        url: `/threads/${data.thread_id}/comments?page=${data.page}&per_page=${data.per_page}`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Comments', id: arg.thread_id }]
    }),

    postComment: builder.mutation<APIResponse, PostCommentProps>({
      query: (data) => ({
        url: `/threads/${data.thread_id}/comments`,
        method: HTTPRequestType.POST,
        data: {
          type: data.type,
          text: data.data.text,
          activity: data.data.activity,
          tagged_accounts: data.data.tagged_accounts,
        },
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Comments', id: arg.thread_id }]
    }),
    updateComment: builder.mutation<APIResponse, { thread_id: string; comment_id: string; text: string; tagged_accounts?: any[] }>({
      query: (data) => ({
        url: `/threads/${data.thread_id}/comments/${data.comment_id}`,
        method: HTTPRequestType.PUT,
        data: {
          text: data.text,
          tagged_accounts: data.tagged_accounts
        },
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Comments', id: arg.thread_id }]
    }),
    deleteComment: builder.mutation<APIResponse, { thread_id: string; comment_id: string }>({
      query: (data) => ({
        url: `/threads/${data.thread_id}/comments/${data.comment_id}`,
        method: HTTPRequestType.DELETE,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Comments', id: arg.thread_id }]
    }),
  }),
});

export const {
  useGetThreadQuery,
  useGetCommentsThreadQuery,
  useLazyGetCommentsThreadQuery,

  usePostCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
} = threadsApi;
